import Footer from '../../components/Footer';
import FyloSection from '../../components/FyloSection';
import Header from '../../components/Header';
import './styles.css';

function Fylo() {

    return (
        <div className="container-home">
            <Header />
            <FyloSection />
            <Footer />
        </div>
    );
}

export default Fylo;